import { SearchCriteria } from "../search-criteria";

export class GetCountriesCriteria extends SearchCriteria {
  public WithCurrentOne: boolean;
}
